module.exports = __webpack_public_path__ + "img/vip-banner-bg.5cc48c10.png";